import React from "react";
import { connect } from "react-redux";

import { Link } from "react-router-dom";
import {
    Card,
    CardHeader,
    CardBody,
    Label,
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
import { selectFilteredList, selectOrderByValue, selectOrderKeyValue } from "./selectors";
import {
    getJobPacks,
    removeJobPack,
    setDateFrom,
    setDateTo,
    setSearchValue,
    setOrderByValue,
    setOrderKeyValue
} from "./actions";

import { formatDate, parseDate } from "react-day-picker/moment";

import DayPickerInput from "react-day-picker/DayPickerInput";

import moment from "moment";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import ArrowUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDownIcon from "@material-ui/icons/ArrowDropDown";
import {
    Typography,
    withStyles,
    Table,
    Button,
    TableBody,
    TableHead,
    TableCell,
    TextField,
    TablePagination,
    TableRow
} from "@material-ui/core";
import PropTypes from "prop-types";

import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5
    }
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };
    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                    color="primary"
                >
                    {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <Button
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    color="primary"
                    aria-label="Previous Page"
                >
                    Previous Page{" "}
                    {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </Button>
                <Button
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                    color="primary"
                >
                    Next Page{" "}
                    {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </Button>
                <IconButton
                    color="primary"
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
    withTheme: true
})(TablePaginationActions);

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3
    },
    tableCell: {
        whiteSpace: "nowrap"
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto",
        width: "100%;"
    },
    col12: { width: "100%" },
    col9: { width: "75%" },
    col6: { width: "50%" },

    col3: { width: "25%" },
    col2: { width: "16.66%" },
    col1: { width: "8.33%" }
});

class JobPack extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createModal: false,
            editModal: false,
            removeModal: false,
            removeJob: false,
            editID: false,
            job_pack: false,
            page: 0,
            rowsPerPage: 50,
            jobObj: [],
            search: ""
        };
        props.getJobPacks();
    }

    checkDate(date) {
        let momentDate = moment(date, "DD/MM/YYYY");
        let currentDate = new moment();
        let futureDate = moment().add(3, "M");
        if (momentDate.isBefore(currentDate)) {
            return "red";
        } else if (momentDate.isAfter(futureDate)) {
            return " #00e600";
        } else {
            return "#ffff00";
        }
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleTableCellsRow = list => {
        return (
            <TableCell
                style={{
                    backgroundColor: list === "No" ? "red" : "white"
                }}
            >
                {list}
            </TableCell>
        );
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    snapshotToArray = snapshot => {
        let returnArr = [];

        snapshot.forEach(childSnapshot => {
            let item = childSnapshot.val();
            item.key = childSnapshot.key;
            returnArr.push(item);
        });

        return returnArr;
    };

    render() {
        const { classes } = this.props;
        const { rowsPerPage, page } = this.state;
        const list = this.props.jobPacks === undefined ? [] : this.props.jobPacks;

        return (
            <div className={classes.root} style={{ width: "100%" }}>
                <Card className={classes.tableWrapper}>
                    <CardHeader>
                        <Label className="mb-0">JobPack List</Label>
                    </CardHeader>
                    <CardBody>
                        <div
                            style={{
                                float: "left",
                                width: "50%",
                                marginTop: "18px",
                                display: "flex",
                                flexDirection: "row"
                            }}
                        >
                            <Link to={`job-packs-form`} style={{ display: "inline" }}>
                                <Button
                                    color="primary"
                                    style={{
                                        width: "auto",
                                        display: "inline"
                                    }}
                                    onClick={() => {}}
                                    variant="contained"
                                    className={classes.button}
                                >
                                    Create Jobpack
                                </Button>
                            </Link>
                            <TextField
                                id="search"
                                placeholder="Search Jobpacks"
                                style={{
                                    display: "inline",
                                    marginLeft: 14,
                                    float: "right"
                                }}
                                value={this.state.search}
                                onChange={event => {
                                    this.setState({
                                        search: event.target.value
                                    });
                                    this.props.setSearchValue(event.target.value);
                                }}
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        </div>
                        <div
                            style={{
                                float: "right",
                                width: "50%",
                                marginTop: "18px",
                                display: "flex",
                                flexDirection: "row"
                            }}
                        >
                            <DayPickerInput
                                value={this.state.dateFrom}
                                placeholder="Single Date"
                                format="LL"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={day => {
                                    this.props.setDateFrom(day);
                                    this.setState({ dateFrom: day });
                                }}
                            />
                            <p>-</p>
                            <DayPickerInput
                                value={this.state.dateTo}
                                placeholder="End Date"
                                format="LL"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={day => {
                                    this.props.setDateTo(day);
                                    this.setState({ dateTo: day });
                                }}
                            />

                            <Button
                                style={{ marginLeft: "5px", marginTop: "-3px" }}
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    this.props.setDateFrom(false);
                                    this.props.setDateTo(false);
                                    this.setState({ dateTo: "", dateFrom: "" });
                                }}
                            >
                                Clear Dates
                            </Button>
                        </div>
                        <div>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan="12">
                                            <TablePagination
                                                colSpan={6}
                                                style={{ float: "right" }}
                                                ActionsComponent={TablePaginationActionsWrapped}
                                                count={list.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                rowsPerPageOptions={[50, 100]}
                                                //ActionsComponent={TablePaginationActionsWrapped}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            className={classes.col1}
                                            onClick={() => {
                                                this.props.setOrderKeyValue("job_id");
                                            }}
                                        >
                                            <b>Jobpack ID</b>
                                            {this.props.orderKey === "job_id" && (
                                                <IconButton
                                                    onClick={() => {
                                                        if (this.props.orderBy === "normal")
                                                            this.props.setOrderByValue("reverse");
                                                        else this.props.setOrderByValue("normal");
                                                    }}
                                                >
                                                    {this.props.orderBy === "normal" ? (
                                                        <ArrowDownIcon />
                                                    ) : (
                                                        <ArrowUpIcon />
                                                    )}
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={classes.col1}
                                            onClick={() => {
                                                this.props.setOrderKeyValue("job_name");
                                            }}
                                        >
                                            <b>Title</b>
                                            {this.props.orderKey === "job_name" && (
                                                <IconButton
                                                    onClick={() => {
                                                        if (this.props.orderBy === "normal")
                                                            this.props.setOrderByValue("reverse");
                                                        else this.props.setOrderByValue("normal");
                                                    }}
                                                >
                                                    {this.props.orderBy === "normal" ? (
                                                        <ArrowDownIcon />
                                                    ) : (
                                                        <ArrowUpIcon />
                                                    )}
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={classes.col2}
                                            onClick={() => {
                                                this.props.setOrderKeyValue("client_name");
                                            }}
                                        >
                                            <b>Client</b>
                                            {this.props.orderKey === "client_name" && (
                                                <IconButton
                                                    onClick={() => {
                                                        if (this.props.orderBy === "normal")
                                                            this.props.setOrderByValue("reverse");
                                                        else this.props.setOrderByValue("normal");
                                                    }}
                                                >
                                                    {this.props.orderBy === "normal" ? (
                                                        <ArrowDownIcon />
                                                    ) : (
                                                        <ArrowUpIcon />
                                                    )}
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={classes.col2}
                                            onClick={() => {
                                                this.props.setOrderKeyValue("start_date");
                                            }}
                                        >
                                            <b>Start Date</b>
                                            {this.props.orderKey === "start_date" && (
                                                <IconButton
                                                    onClick={() => {
                                                        if (this.props.orderBy === "normal")
                                                            this.props.setOrderByValue("reverse");
                                                        else this.props.setOrderByValue("normal");
                                                    }}
                                                >
                                                    {this.props.orderBy === "normal" ? (
                                                        <ArrowDownIcon />
                                                    ) : (
                                                        <ArrowUpIcon />
                                                    )}
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={classes.col2}
                                            onClick={() => {
                                                this.props.setOrderKeyValue("end_date");
                                            }}
                                        >
                                            <b>End Date</b>
                                            {this.props.orderKey === "end_date" && (
                                                <IconButton
                                                    onClick={() => {
                                                        if (this.props.orderBy === "normal")
                                                            this.props.setOrderByValue("reverse");
                                                        else this.props.setOrderByValue("normal");
                                                    }}
                                                >
                                                    {this.props.orderBy === "normal" ? (
                                                        <ArrowDownIcon />
                                                    ) : (
                                                        <ArrowUpIcon />
                                                    )}
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={classes.col2}
                                            onClick={() => {
                                                this.props.setOrderKeyValue("description_of_works");
                                            }}
                                        >
                                            <b>Description</b>
                                            {this.props.orderKey === "description_of_works" && (
                                                <IconButton
                                                    onClick={() => {
                                                        if (this.props.orderBy === "normal")
                                                            this.props.setOrderByValue("reverse");
                                                        else this.props.setOrderByValue("normal");
                                                    }}
                                                >
                                                    {this.props.orderBy === "normal" ? (
                                                        <ArrowDownIcon />
                                                    ) : (
                                                        <ArrowUpIcon />
                                                    )}
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell className={classes.col3}>
                                            <b>Actions</b>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(list)
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((e, i) => {
                                            return (
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {list[e].job_id}
                                                    </TableCell>
                                                    <TableCell>{list[e].job_name}</TableCell>
                                                    <TableCell>{list[e].client_name}</TableCell>
                                                    <TableCell>{list[e].start_date}</TableCell>
                                                    <TableCell>{list[e].end_date}</TableCell>
                                                    <TableCell>
                                                        {list[e].description_of_works}
                                                    </TableCell>

                                                    <TableCell
                                                        xs={3}
                                                        style={{
                                                            minWidth: 200
                                                        }}
                                                    >
                                                        <Link
                                                            to={`job-pack/job-pack-profile/${
                                                                list[e].job_id
                                                            }`}
                                                        >
                                                            <IconButton
                                                                color="secondary"
                                                                style={{
                                                                    border: "1px solid indigo",
                                                                    color: "indigo",
                                                                    margin: 2
                                                                }}
                                                            >
                                                                <ViewIcon />
                                                            </IconButton>
                                                        </Link>
                                                        <Link
                                                            to={`job-pack/job-pack-edit/${
                                                                list[e].job_id
                                                            }`}
                                                        >
                                                            <IconButton
                                                                color="secondary"
                                                                style={{
                                                                    border: "1px solid indigo",
                                                                    color: "indigo",
                                                                    margin: 2
                                                                }}
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Link>
                                                        <IconButton
                                                            color="secondary"
                                                            style={{
                                                                border: "1px solid red",
                                                                color: "red",
                                                                margin: 2
                                                            }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    createModal: false,
                                                                    removeModal: true,
                                                                    editModal: false,
                                                                    removeJob: list[e]
                                                                });
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>

                <Modal isOpen={this.state.removeModal}>
                    <ModalHeader>Remove JobPack</ModalHeader>
                    <ModalBody>
                        <Typography>Are you sure you want to remove this Job JobPack?</Typography>
                        <Row>
                            <Col>
                                <Label>JobPack Title</Label>

                                <p>
                                    <b>{this.state.qualification_title}</b>
                                </p>
                            </Col>
                            <Col>
                                <Label>JobPack Description</Label>
                                <p>
                                    <b>{this.state.qualification_desc}</b>
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                                this.props.removeJobPack(this.state.removeJob);
                                this.setState({ removeJob: false });
                            }}
                        >
                            Remove
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect(
    store => {
        return {
            jobPacks: selectFilteredList(store),
            orderKey: selectOrderKeyValue(store),
            orderBy: selectOrderByValue(store)
        };
    },
    {
        getJobPacks,
        setSearchValue,
        removeJobPack,
        setDateFrom,
        setDateTo,
        setOrderByValue,
        setOrderKeyValue
    }
)(withStyles(styles)(JobPack));
